import React from "react";
import { motion } from "framer-motion";
import { Lines, FadeUp } from "../components/Reveal";

export default function Community() {
    return (
        <section data-testid="community-gallery" className="mx-auto max-w-[1600px] px-5 py-24 sm:px-8 lg:px-16 lg:py-36">
            <div className="mb-14 text-center">
                <Lines
                    lines={["@vantageownersclub"]}
                    className="font-display text-2xl font-extrabold uppercase tracking-tight text-[#0A0A0A] sm:text-4xl"
                />
                <p className="mt-4 text-[9px] uppercase tracking-[0.4em] text-[#6B6A66]">Worn by the club</p>
            </div>
            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6 lg:gap-4">
                {[1, 2, 3, 4, 5, 6].map((n, i) => (
                    <FadeUp key={n} delay={i * 0.06}>
                        <motion.div
                            animate={{ y: [0, -9, 0] }}
                            transition={{ duration: 4.5 + i * 0.4, repeat: Infinity, ease: "easeInOut", delay: i * 0.5 }}
                        >
                            <div data-cursor="EXPLORE" className="group aspect-[4/5] overflow-hidden bg-[#ECEAE4]">
                                <img
                                    src={`/assets/COMMUNITY_0${n}.jpg`}
                                    alt={`Community member ${n} wearing Vantage Owners Club`}
                                    loading="lazy"
                                    className="h-full w-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-105"
                                />
                            </div>
                        </motion.div>
                    </FadeUp>
                ))}
            </div>
        </section>
    );
}
